module.exports = __webpack_public_path__ + "img/decode2.9df619ff.jpg";